/* @flow */

import { enableInitializing } from 'initializable-reducer';
import type { Action } from '../diplomatico/types';

const initialState = {
  active: false,
  student: {}
};

function studentCommentsModal(state: Object = initialState, { type, payload }: Action) {
  switch (type) {
    case 'SHOW_STUDENT_COMMENTS_MODAL':
      return {
        active: true,
        ...payload
      };
    case 'HIDE_STUDENT_COMMENTS_MODAL':
      return { ...initialState };
    case 'SET_MODAL_STUDENT_COMMENTS':
      return {
        ...state,
        ...payload
      };
    default:
      return state;
  }
}

export {
  studentCommentsModal,
  initialState
};

export default enableInitializing(studentCommentsModal);
